import { Component, Input, OnInit } from '@angular/core';
import { NewsService } from '../../services/news.service';
import { NewsListModel } from '../../models/news-list.model';

@Component({
    selector: 'app-news-list',
    templateUrl: './news-list.component.html',
    styleUrl: './news-list.component.scss'
})
export class NewsListComponent implements OnInit {
    @Input() maxNewsCount: number | null = null;
    @Input() displayEmptyInformation: boolean = false;
    @Input() displayLoadingIndicator: boolean = false;
    @Input() excludeRead: boolean = false;

    newsModel!: NewsListModel[];

    constructor(private newsService: NewsService) { }

    ngOnInit(): void {
        this.loadnews();
    }

    private loadnews() {
        this.newsService.getNews(this.excludeRead).subscribe({
            next: (news) => {
                this.newsModel = this.sortDates(news);
            },
        })
    }

    private sortDates(news: NewsListModel[]): NewsListModel[] {
        return news.sort((a, b) => {
            const aFrom = new Date(a.publicationFrom);
            const bFrom = new Date(b.publicationFrom);
            const aTo = new Date(a.publicationTo);
            const bTo = new Date(b.publicationTo);

            // First, sort by publication start date
            if (aFrom.getTime() !== bFrom.getTime()) {
                return bFrom.getTime() - aFrom.getTime();
            }

            // If start dates are the same, sort by end date
            return bTo.getTime() - aTo.getTime();
        });
    }
}
